import { render } from "./motion-status-badge.vue?vue&type=template&id=496e9c74"
import script from "./motion-status-badge.vue?vue&type=script&lang=js"
export * from "./motion-status-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__